<template>
  <alzata-dialog
    ref="modal"
    :title="veterinarian?.id ? 'Edit Veterinarian' : 'Create Veterinarian'"
  >
    <div class="row g-2">
      <div class="col-12">
        <label for="name" class="small">Name *</label>
        <input
          id="name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.name }"
          placeholder="Name"
          v-model="name"
        />
        <div v-if="errors.name" class="invalid-feedback">
          Name is required.
        </div>

        <label for="doctor" class="small">Doctor</label>
        <input
          id="doctor"
          type="text"
          class="form-control"
          placeholder="Doctor"
          v-model="doctor"
        />

        <label for="hours" class="small">Hours</label>
        <input
          id="hours"
          type="text"
          class="form-control"
          placeholder="Hours"
          v-model="hours"
        />

        <label for="address" class="small">Address</label>
        <input
          id="address"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.address }"
          placeholder="Address"
          v-model="address"
        />
        <div v-if="errors.address" class="invalid-feedback">
          Address is required.
        </div>

        <label for="phoneFriendly" class="small">Phone Friendly *</label>
        <input
          id="phoneFriendly"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.phoneFriendly }"
          placeholder="Phone Friendly"
          v-model="phoneFriendly"
        />
        <div v-if="errors.phoneFriendly" class="invalid-feedback">
          Phone friendly is required.
        </div>

        <label for="phone" class="small">Phone *</label>
        <input
          id="phone"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.phone }"
          placeholder="Phone"
          v-model="phone"
        />
        
        <div v-if="errors.phone" class="invalid-feedback">
          Phone is required.
        </div>

        <label for="emergencyPhoneFriendly" class="small"
          >Emergency Phone Friendly</label
        >
        <input
          id="emergencyPhoneFriendly"
          type="text"
          class="form-control"
          placeholder="Emergency Phone Friendly"
          v-model="emergencyPhoneFriendly"
        />
        <label for="emergencyPhone" class="small">Emergency Phone</label>
        <input
          id="emergencyPhone"
          type="text"
          class="form-control"
          placeholder="Emergency Phone"
          v-model="emergencyPhone"
        />
        <label for="email" class="small">Email</label>
        <input
          id="email"
          type="email"
          class="form-control"
          placeholder="Email"
          v-model="email"
        />
        <label for="website" class="small">Website</label>
        <input
          id="website"
          type="url"
          class="form-control"
          placeholder="Website"
          v-model="website"
        />
        <label for="isEmergency" class="small">Is Emergency?</label>
        <input
          id="isEmergency"
          type="checkbox"
          class="form-check-input"
          v-model="isEmergency"
        />
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="hideEditVeteranarian">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="save">Save</button>
    </template>
  </alzata-dialog>
</template>

<script>
export default {
  name: "EditVeterinarianDialog",
  emits: ["save"],
  data() {
    return {
      veterinarian: null,
      name: null,
      doctor: null,
      hours: null,
      address: null,
      phoneFriendly: null,
      phone: null,
      emergencyPhoneFriendly: null,
      emergencyPhone: null,
      email: null,
      website: null,
      isEmergency: null,
      errors: {
        name: false,
        address: false,
        phone: false,
        phoneFriendly: false,
      },
    };
  },
  methods: {
    clearValidation() {
      this.errors.name = false;
      this.errors.address = false;
      this.errors.phone = false;
      this.errors.phoneFriendly = false;
    },
    show(veterinarian) {
      this.veterinarian = veterinarian;
      this.name = veterinarian.name;
      this.doctor = veterinarian.doctor;
      this.hours = veterinarian.hours;
      this.address = veterinarian.address;
      this.phoneFriendly = veterinarian.phoneFriendly;
      this.phone = veterinarian.phone;
      this.emergencyPhoneFriendly = veterinarian.emergencyPhoneFriendly;
      this.emergencyPhone = veterinarian.emergencyPhone;
      this.email = veterinarian.email;
      this.website = veterinarian.website;
      this.isEmergency = veterinarian.isEmergency;

      this.clearValidation();

      this.$refs.modal.show();
    },
    hideEditVeteranarian() {
      this.clearValidation();
      this.$refs.modal.hide();
    },
    save() {
      this.errors.name = !this.name;
      this.errors.address = !this.address;
      this.errors.phone = !this.phone;
      this.errors.phoneFriendly = !this.phoneFriendly;
   
      if (this.errors.name || this.errors.address || this.errors.phone || this.errors.phoneFriendly) {
        return;
      }

      this.$emit("save", {
        id: this.veterinarian.id,
        name: this.name,
        doctor: this.doctor,
        hours: this.hours,
        address: this.address,
        phoneFriendly: this.phoneFriendly,
        phone: this.phone,
        emergencyPhoneFriendly: this.emergencyPhoneFriendly,
        emergencyPhone: this.emergencyPhone,
        email: this.email,
        website: this.website,
        isEmergency: this.isEmergency,
      });
    },
  },
};
</script>
